<template>
<div id="page-templates" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Administrar Tipos de Industria" class="elevation-1 px-5 py-3" >
                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>

                        <v-dialog v-model="modal" max-width="500px" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon @click.native="modal = false" class="white--text" >cancel</v-icon>
                                        <span class="subheading" >
                                            <strong>{{ update ? "Actualizar" : "Nuevo" }} Tipo</strong>
                                        </span>
                                    </v-card>                                    
                                </v-card-title>

                                <v-card-text>
                                    <v-form ref="form" lazy-validation>
                                        <v-container grid-list-md>
                                            <v-layout wrap>
                                                <v-flex xs12>
                                                    <v-text-field label="Nombre" v-model="model.nombre" :rules="[rules.required]" ></v-text-field>
                                                </v-flex>

                                                <v-flex xs12>
                                                    <v-select :items="estatus" v-model="model.activo" label="Estatus" item-text="texto" item-value="key" single-line :rules="[rules.required]" ></v-select>
                                                </v-flex>

                                            </v-layout>
                                        </v-container>
                                    </v-form>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>

                                    <v-btn @click.native="modal = false" >
                                        <v-icon>cancel</v-icon> Cancelar
                                    </v-btn>
                                    <v-btn color="success" @click.native="update ? updateTipo() : saveTipo()" >
                                        <v-icon>done</v-icon>
                                        {{ update ? "Actualizar" : "Guardar" }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid" >

                            <v-client-table ref="vuetable" :data="items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                                </template>

                                <template slot="activo" slot-scope="props" >
                                    <span v-if="props.row.activo == 1" >Activo</span>
                                    <span v-else>Desactivado</span>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-btn x-small fab dark color="blue" @click.native="getTipo(props.row)" title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="deleteTipo(props.row.id_tipo_empresa)" title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>
                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";

export default {
    created: function () {        
        this.getTipos();
    },
    data() {
        return {
            fab: false,
            estatus: [{
                key: 1,
                texto: 'Activo'
            }, {
                key: 2,
                texto: 'Desactivado'
            }],
            items: [],
            name: "datagrid",
            columns: [
                "nombre",
                "activo",
                "actions"
            ],
            show_loading: true,
            options: {
                filterable: ["nombre"],
                sortable: ["nombre"],

                headings: {
                    nombre: "Nombre",
                    activo: "Estatus",
                    actions: "Operaciones"
                }
            },            
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Catálogos",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Tipos de Industria",
                    disabled: true,
                    href: ""
                }
            ],
            title: "",
            modal: false,
            update: false,
            estados: [],
            model: {
                nombre: "",
                activo: ""
            },
            rules: {
                required: v => !!v || "Este campo es requerido",
            },

        };
    },

    methods: {
        openModal: function (type) {
            if (type === 1) {
                this.limpiarModel();
                this.update = false;
            } else
                this.update = true;

            this.modal = true;
        },
        limpiarModel: function () {
            for (var k in this.model)
                this.model[k] = "";
        },
        getTipos: function () {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            axios
                .get(this.$hostname + "catalogos/tipos_empresas/", {
                    'cliente': this.model.cliente
                })
                .then(response => {
                    this.items = response.data;
                    this.$root.$dialogLoader.hide();
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener los tipos.",
                        footer: ""
                    });
                    this.$root.$dialogLoader.hide();
                });
        },
        saveTipo: function () {
            if (this.$refs.form.validate()) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

                axios
                    .post(this.$hostname + "catalogos/tipos_empresas/", this.model)
                    .then(response => {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El tipo se creó correctamente.",
                            footer: ""
                        });

                        this.modal = false;                        
                    })
                    .catch(error => {
                        var mensaje = "";
                        if (error.response != undefined && error.response.data != undefined){                            
                            for (var item in error.response.data){                                
                                mensaje += item+": "+error.response.data[item];
                            }                            
                        }
                        
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al crear el tipo",
                            footer: mensaje,
                        });
                        this.$root.$dialogLoader.hide();
                    }).then(()=>{
                        this.$root.$dialogLoader.hide();
                        this.getTipos();
                    });
            }
        },
        getTipo: function (row) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            this.model.nombre = row.nombre;
            this.model.activo = row.activo;
            this.model.id_tipo_empresa = row.id_tipo_empresa;

            this.$root.$dialogLoader.hide();
            this.openModal(2);
        },
        updateTipo: function () {
            let id_tipo_empresa = this.model.id_tipo_empresa;

            if (this.$refs.form.validate()) {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

                axios
                    .put(this.$hostname + "catalogos/tipos_empresas/" + id_tipo_empresa + "/", this.model)
                    .then(response => {
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El tipo se actualizó correctamente.",
                            footer: ""
                        });                                                
                        this.modal = false;
                    })
                    .catch(error => {
                        var mensaje = "";
                        if (error.response != undefined && error.response.data != undefined){                            
                            for (var item in error.response.data){                                
                                mensaje += item+": "+error.response.data[item];
                            }                            
                        }
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al actualizar el tipo",
                            footer: mensaje
                        });
                    }).then(()=>{
                        this.$root.$dialogLoader.hide();
                        this.getTipos();
                    });
            }
        },
        deleteTipo: function (id_tipo_empresa) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value) {
                    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                    axios
                        .delete(this.$hostname + "catalogos/tipos_empresas/" + id_tipo_empresa + "/")
                        .then(response => {
                            this.$swal({
                                type: "success",
                                title: "Operación Exitosa",
                                text: "El tipo se eliminó correctamente.",
                                footer: ""
                            });                            
                        })
                        .catch(error => {
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un error al eliminar un tipo",
                                footer: ""
                            });
                        }).then(()=>{
                            this.$root.$dialogLoader.hide();
                            this.getTipos();
                        });
                }
            });
        }
    }
};
</script>
